module.exports = "\n<header>\n  <navbar links=\"$ctrl.links\"></navbar>\n</header>\n\n<div class=\"container content\">\n  <div ui-view></div>\n</div>\n\n<footer></footer>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/app.html
 ** module id = 39
 ** module chunks = 0
 **/